
<div class="fancy-hero-one coutom_header">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 m-auto hdr_with_btn">
        <h3 class="font-rubik">User Charges Services</h3> 
        <div *ngIf="user_details" class="user_dtl">
          <a class="logout_wrap" (click)="logout()"><img  src="assets/images/assets/logout.png" alt="Logout" title="Logout" /></a>
          <span><a [routerLink]="['/user-property-list']">{{name}}</a></span>
        </div>
        <div *ngIf="!user_details" class="login_reg">
          <a [routerLink]="['/login']">Login</a>
          <span> / </span>
          <a [routerLink]="['/register']">Register</a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="hero-banner-one contact-us-light">
  <div class="hero-upper-container">
    <div class="container d-flex align-items-center justify-content-center">
      <form #subForm="ngForm" (submit)="getBillData()" class="">
      <div class="form-style-light search_property">
        <div class="row controls">
          <div class="col-md-12">
            <div class="input-group-meta form-group mb-25">
              <label>Asset ID</label>
              <input type="text" placeholder="Enter Asset ID" [(ngModel)]="property_id" name="property_id" required>
              <p style="color: red;">{{invalid_propId}}</p>
            </div>
          </div>
          <div class="col-12 d-flex align-items-center justify-content-center"><button type="submit" [disabled]="!subForm.valid" class="theme-btn-one btn-lg">Submit</button></div>
        </div>
        <!-- <p class="sing-in-call"><a [routerLink]="['/search-property']">Click Here</a> to search your Property ID.</p> -->

        <p style="margin-bottom: 10px;">Or</p>

        <div class="col-12 d-flex align-items-center justify-content-center">
          <button class="theme-btn-one btn-lg" (click)="registerProperty()">Register New Asset</button>
        </div>

        <p *ngIf="!user_details" class="sing-in-call"><a [routerLink]="['/login']">Already Registered? Login to View & Pay Your Bills</a></p>
        <p *ngIf="user_details" class="sing-in-call"><a [routerLink]="['/user-property-list']">View & Pay Your Bills</a></p>


      </div>
    </form>

    </div>

    <div class="mt-35 note_box"> 
      <span>
          *Note- The User Charges (Sanitation Fee) data is regularly updated and available for users to download without the need to visit the department."
        </span>
      </div>
  </div> <!-- /.hero-upper-container -->
</div>

<ngb-toast class="fixed_message sucess" *ngIf="isMessageShow" [autohide]="true" (hide)="isMessageShow = false"
            [delay]="5000">
            You Logged Out Successfully.
</ngb-toast>